"use client";

import { c as _c } from "react/compiler-runtime";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ApiIdentity } from "../../../generated/models/ApiIdentity";
import CreateWave from "./CreateWave";
interface CreateWaveModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly profile: ApiIdentity;
}
export default function CreateWaveModal(t0) {
  const $ = _c(8);
  const {
    isOpen,
    onClose,
    profile
  } = t0;
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
      return () => setMounted(false);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!mounted) {
    return null;
  }
  let t3;
  if ($[2] !== isOpen || $[3] !== onClose || $[4] !== profile) {
    t3 = isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px] tw-flex tw-items-start lg:tw-items-center tw-justify-center tw-z-[9999] tw-px-4 tw-pb-4 tw-pt-[calc(env(safe-area-inset-top,0px)+1rem)]" onClick={onClose}><motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="tw-bg-iron-950 tw-rounded-xl tw-w-full tw-max-w-5xl tw-max-h-[90vh] tw-overflow-hidden tw-shadow-2xl" onClick={_temp}><div className="tw-flex tw-items-center tw-justify-between tw-p-6 tw-border-b tw-border-iron-800"><h2 className="tw-text-2xl tw-font-bold tw-text-white">Create Wave</h2><button onClick={onClose} className="tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-size-9 lg:tw-size-10 tw-rounded-full tw-border-0 tw-ring-1 tw-ring-iron-700 tw-bg-transparent tw-text-iron-300 desktop-hover:hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out" aria-label="Close modal"><XMarkIcon className="tw-w-6 tw-h-6 tw-flex-shrink-0" /></button></div><div className="tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-transition-colors tw-duration-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300 tw-max-h-[calc(90vh-80px)]"><div className="tw-px-6 tw-pb-8"><CreateWave profile={profile} onBack={onClose} onSuccess={onClose} /></div></div></motion.div></motion.div>;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = profile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = createPortal(<AnimatePresence>{t3}</AnimatePresence>, document.body);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(e) {
  return e.stopPropagation();
}